import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {  SharedService } from '../../shared.service';
import { ApiService } from '../../api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-details',
  templateUrl: './search-details.component.html',
  styleUrl: './search-details.component.scss'
})
export class SearchDetailsComponent {
  term: string = '';
  searched_string = '';
  emptyData: boolean=true;
  results:any=[];
  show: any = {
    doctor: false,
    contract: false,
    patient: false,
    partner: false,
    payments: false,
    ar: false,
    proposal: false,
    pa_leads: false,
    training:false,
    assignments: false,
    callback_assignments: false,
    settled_accounts: false
  };
  public searchSubscription: Subscription | undefined;
  public search_type:any
  public pageNumber: number = 1;
  public totalRows:any=0;

  constructor(
    private route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public _shared: SharedService,
    private _api: ApiService
  ) {
  }
// .pipe(
//       map(params => params['search']),// map value according to search then send to next operators and subsciber
//       distinctUntilChanged(),//to avoid duplicate API calls for the same value in one row
//     )
  ngOnInit() {
    this.searchSubscription = this.route.queryParams.subscribe((data: any) => {
       this.search_type=data.search_type
       this.show[data.search_type]=true;
        this.searchData(data.search);
        this.handleSearch();
     
    });
  }

  searchData(data: any) {
    this.term = data;
    if (!(/[a-zA-Z]/.test(this.term + '')) && (/[0-9]/.test(this.term + ''))) {
        const number = (this.term + '').replace(/[^\d]/g, '');
        this.term = number + '';
    }
    console.log(this.term);

  }

  search(){
    this.searchData(this.term);
    this.router.navigate(['/app/details-search'], {queryParams: {search: this.term, search_type:this.search_type}, queryParamsHandling: 'merge'})
  }

  handleSearch() {
    if (!this.term) {
      this._shared.customPopups('Enter a value to search', 2);
      return;
    }
    let data = {
      search_string: this.term,
      search_type:this.search_type,
      page:this.pageNumber
    };
    this._api.api(data, 'dashboard/details-search', 'get')
      .subscribe((res: any) => {
        console.log(res);
        this.results=res.list;
        this.totalRows=res.count;
        if(this.results &&  this.results.length>0) {
         this.searched_string = this.term;
          this.emptyData = false;
        } else {
           this.emptyData = true;
          this._shared.customPopups('No results found!', 1);
        }
      });
  }
  viewPartner(partner_id: any) {
    // MainService.customSetItem("partnerList", partner_id);
    this.router.navigate(['app', 'partners', 'profile', partner_id]);
  }

  pageChanged(event: any) {
    this.pageNumber = event.page;
    this.handleSearch();
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    } 
  }
}